module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/cs-card-drag.821c21b0b71ea816142f.gif";